<div
  class="notification-bell"
  ngbDropdown
  container="body"
  (openChange)="onDropdownChange($event)">
  <button
    class="btn toggle-btn"
    ngbDropdownToggle
    [title]="'Notificações'">
    <i class="fas fa-bell"></i>
    <span
      class="notification-badge"
      *ngIf="(unreadCount$ | async) > 0">
      {{ (unreadCount$ | async) > 99 ? '99+' : (unreadCount$ | async) }}
    </span>
  </button>

  <div
    ngbDropdownMenu
    class="notification-dropdown">
    <div class="notification-header">
      <span class="notification-title">Notificações</span>
    </div>

    <div class="notification-list">
      <ng-container *ngIf="(notifications$ | async)?.length > 0; else emptyState">
        <div
          *ngFor="let notification of (notifications$ | async); trackBy: trackByNotificationId"
          class="notification-item"
          [class.unread]="!notification.read"
          (click)="onNotificationClick(notification)">
          <div class="notification-icon" [ngClass]="getColorClass(notification.type)">
            <i [class]="getIcon(notification.type)"></i>
          </div>
          <div class="notification-content">
            <div class="notification-item-title">{{ notification.title }}</div>
            <div class="notification-message">{{ notification.message }}</div>
            <div class="notification-time">{{ getTimeAgo(notification.createdAt) }}</div>
          </div>
        </div>
      </ng-container>

      <ng-template #emptyState>
        <div class="notification-empty">
          <i class="fas fa-bell-slash"></i>
          <p>Nenhuma notificação</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
